import React from 'react';
import {
  VStack,
  Select,
  SelectTrigger,
  SelectInput,
  SelectIcon,
  SelectPortal,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicatorWrapper,
  SelectDragIndicator,
  SelectItem,
  Icon,
  ChevronDownIcon,
  Button,
  ButtonText,
  HStack,
  Spinner,
} from '@gluestack-ui/themed';
import useData from '../hooks/useData';

const CohortSelector = ({ onConfirm, onCancel, isLoading = false }) => {
  const { data: cohorts, isLoading: isLoadingCohorts } = useData({
    objectName: 'cohorts',
    filter: { state: 'active', isDeprecated: false },
  });

  const [selectedCohortId, setSelectedCohortId] = React.useState('');

  return (
    <VStack space="lg" mt="$4">
      {isLoadingCohorts ? (
        <HStack space="sm" alignItems="center" justifyContent="center" p="$4">
          <Spinner size="small" />
        </HStack>
      ) : (
        <Select
          selectedValue={selectedCohortId}
          onValueChange={(value) => setSelectedCohortId(value)}
        >
          <SelectTrigger variant="outline" size="md">
            <SelectInput placeholder="Select cohort" />
            <SelectIcon mr="$3">
              <Icon as={ChevronDownIcon} />
            </SelectIcon>
          </SelectTrigger>
          <SelectPortal>
            <SelectBackdrop />
            <SelectContent>
              <SelectDragIndicatorWrapper>
                <SelectDragIndicator />
              </SelectDragIndicatorWrapper>
              <SelectItem label="None" value="" />
              {cohorts.map((cohort) => (
                <SelectItem key={cohort.id} label={cohort.title} value={cohort.id} />
              ))}
            </SelectContent>
          </SelectPortal>
        </Select>
      )}

      <HStack space="md" justifyContent="flex-end" mt="$4">
        <Button variant="outline" action="secondary" onPress={onCancel} isDisabled={isLoading || isLoadingCohorts}>
          <ButtonText>Cancel</ButtonText>
        </Button>
        <Button
          action="primary"
          onPress={() => onConfirm(selectedCohortId)}
          isDisabled={isLoading || isLoadingCohorts}
        >
          <ButtonText>Confirm Assignment</ButtonText>
        </Button>
      </HStack>
    </VStack>
  );
};

export default CohortSelector;
